import { render, staticRenderFns } from "./TaskTodos.vue?vue&type=template&id=735691e5&"
import script from "./TaskTodos.vue?vue&type=script&lang=js&"
export * from "./TaskTodos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports